// src/components/shared/Modal.js
import React from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: ${props => props.$zIndex || 1100};
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding: 20px 16px 80px 16px;
`;

const ModalContent = styled.div`
  background-color: ${(props) => props.theme.colors.background};
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  width: 400px;
  max-width: 100%;
  margin: auto;
`;

const ModalHeader = styled.div`
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
`;

const Button = styled.button`
  background-color: ${(props) => props.theme.colors.primary};
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.primaryDark};
  }

  &.cancel {
    background-color: ${(props) => props.theme.colors.error};
  }
`;

const Modal = ({ message, onConfirm, onCancel, title, children, isOpen, hideFooter, zIndex, disableBackdropClose }) => {
  if (!isOpen) return null;
  return (
    <ModalOverlay
      $zIndex={zIndex}
      onClick={(e) => { if (!disableBackdropClose && e.target === e.currentTarget && onCancel) onCancel(); }}
    >
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalHeader>{title}</ModalHeader>
        {message && <p>{message}</p>}
        {children}
        {!hideFooter && (
          <ModalFooter>
            <Button type='button' onClick={onCancel} className="cancel">Cancel</Button>
            <Button type="button" onClick={onConfirm}>Confirm</Button>
          </ModalFooter>
        )}
      </ModalContent>
    </ModalOverlay>
  );
};

export default Modal;
